/* Makes every footer on the site carry the same link columns, and the same
   company line. v3.

   v1 made the hand-built templates carry the two columns the shared page-foot
   snippet already had: "What it does" and "Rockkt". It skipped any footer that
   already had them.

   v2 added a "Features" column with the six pages that used to be homepage
   sections, everywhere, including the footers the snippet renders, and restyled
   the grid to four tracks.

   v3 is v2 with two more features in that column: Rockkt One and Playbooks,
   eight in total. Same order as the header menu (rockkt-nav-features-v2.js) and
   the band at the foot of the homepage (rockkt-router-v5.js). Change them in
   all three or in none.

   Playbooks points at /pages/send-playbooks, not /pages/playbooks: that handle
   belongs to the guides hub, which is content rather than product. The guides
   hub is reachable from Mission Control and the other content pages; it is
   deliberately not in this column, which is features only. */
(function () {
  var FEATURE_PAGES = [
    ['/pages/rockkt-one',     'Rockkt One'],
    ['/pages/send-playbooks', 'Playbooks'],
    ['/pages/gift-lab',       'Gift Lab'],
    ['/pages/design-studio',  'Design Studio'],
    ['/pages/flight-deck',    'Flight Deck'],
    ['/pages/tracking',       'Tracking'],
    ['/pages/navigator',      'Navigator'],
    ['/pages/compliance',     'Compliance']
  ];
  var WHAT_IT_DOES = [
    ['/pages/find-the-address', 'Find the address'],
    ['/pages/write-the-letter', 'Write the letter'],
    ['/pages/design-the-envelope', 'Design the envelope'],
    ['/pages/landing-pages', 'Land the page'],
    ['https://rockkt.com/blogs/how-rockkt-helps', 'Mission Control']
  ];
  var ROCKKT = [
    ['/pages/compare', 'Straight Comparison'],
    ['/pages/pricing', 'Pricing'],
    ['/pages/faq', 'Questions & Answers'],
    ['/pages/the-boring-stuff', 'The Boring Stuff'],
    ['/pages/request-an-invite', 'Join Rockkt']
  ];

  function column(heading, links, cls) {
    var col = document.createElement('div');
    col.className = 'foot-col foot-links ' + cls;
    var h = document.createElement('h4');
    h.textContent = heading;
    col.appendChild(h);
    links.forEach(function (l) {
      var a = document.createElement('a');
      a.href = l[0];
      a.textContent = l[1];
      col.appendChild(a);
    });
    return col;
  }

  function layout(grid) {
    var cols = grid.querySelectorAll('.foot-col').length;
    var w = window.innerWidth;
    if (w <= 620)      grid.style.gridTemplateColumns = '1fr';
    else if (w <= 960) grid.style.gridTemplateColumns = '1fr 1fr';
    else               grid.style.gridTemplateColumns = '1.4fr' + ' 1fr'.repeat(cols);
  }

  function sync() {
    var grid = document.querySelector('footer .foot-grid');
    if (!grid) return;

    /* The two v1 columns, for footers that still only carry "Explore". */
    if (!grid.querySelector('.rk-synced') && grid.textContent.indexOf('Find the address') === -1) {
      grid.querySelectorAll('.foot-col.foot-links').forEach(function (old) { old.remove(); });
      grid.appendChild(column('What it does', WHAT_IT_DOES, 'rk-synced'));
      grid.appendChild(column('Rockkt', ROCKKT, 'rk-synced'));
    }

    /* The Features column, for every footer. First link column, after the brand.
       v2 built this with six links; a page that has a v2-built column cached is
       replaced rather than left short. */
    var existing = grid.querySelector('.rk-features');
    if (existing && existing.querySelectorAll('a').length !== FEATURE_PAGES.length) {
      existing.parentNode.removeChild(existing);
      existing = null;
    }
    if (!existing) {
      var first = grid.querySelector('.foot-col');
      var col = column('Features', FEATURE_PAGES, 'rk-features');
      if (first) grid.insertBefore(col, first); else grid.appendChild(col);
    }

    layout(grid);
  }

  /* The company line. The shared snippet carries the corrected wording; the
     hand-built footers each hold their own copy inside files the Admin API
     will not replace as text, so one word is corrected here. Idempotent: it
     only acts on a span that still says the old thing. */
  function name() {
    var spans = document.querySelectorAll('footer .foot-bottom span');
    for (var i = 0; i < spans.length; i++) {
      var t = spans[i].textContent;
      if (t.indexOf('Rockkt Ltd.') > -1) spans[i].textContent = t.replace('Rockkt Ltd.', 'Rockkt.');
    }
  }

  function run() { sync(); name(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  window.addEventListener('load', run);
  var rt = null;
  window.addEventListener('resize', function () {
    if (rt) clearTimeout(rt);
    rt = setTimeout(function () { var g = document.querySelector('footer .foot-grid'); if (g) layout(g); }, 120);
  });
})();
